// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useUniqueId } from '@tectonics/hooks';
import { RadioButton } from '../atoms';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

type Props = {|
  name?: string,
  label?: Node,
  value?: string | number;
  checked?: boolean,
  disabled?: boolean,
  onFocus?: (event: SyntheticFocusEvent<HTMLInputElement>) => void,
  onBlur?: (event: SyntheticFocusEvent<HTMLInputElement>) => void,
  onChange?: (event: SyntheticInputEvent<HTMLInputElement>) => void,
  displayBrand?: Node,
|};

export function InputRadioField(props: Props): Node {
  const { name, label, displayBrand, ...rest } = props;
  const inputId = useUniqueId();

  return (
    <Label htmlFor={inputId}>
      <RadioButton
        id={inputId}
        name={name || inputId}
        data-test-value={props.value}
        {...rest}
      />

      <LabelTextWrapper>
        {label}
      </LabelTextWrapper>

      {displayBrand && (
        <DisplayBrandsWrapper>
          {displayBrand}
        </DisplayBrandsWrapper>
      )}
    </Label>
  );
}

const Label = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
`;

const LabelTextWrapper = styled.span`
  margin-left: 12px;
  font-size: 0.9em;
  font-weight: 600;
  flex-grow: 1;
  color: #1a1a19;
  font-family: ${theme.fontFamily.sansSerif};
`;

const DisplayBrandsWrapper = styled.div`
  height: 20px;
`;
